// import React, { useState } from 'react';


// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   return (
//     <header className="fixed top-0 left-0 right-0 bg-white z-[1000] py-3 sm:py-4 transition-all duration-300 border-b border-gray-200">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex items-center justify-between w-full">
//           <div className="flex items-center flex-shrink-0">
//             <img src={logo} alt="Tennis Community Logo" className="h-10 sm:h-12 w-auto object-contain filter-none" />
//           </div>
          
//           <nav className={`${
//             isMenuOpen 
//               ? 'fixed top-[64px] sm:top-[72px] left-0 right-0 bg-white flex flex-col py-6 px-4 transform translate-y-0 shadow-xl border-t border-gray-200 z-50' 
//               : 'fixed top-[64px] sm:top-[72px] left-0 right-0 bg-white flex flex-col py-6 px-4 transform -translate-y-full shadow-xl border-t border-gray-200 z-50 md:relative md:top-auto md:left-auto md:right-auto md:bg-transparent md:flex-row md:py-0 md:px-0 md:transform-none md:shadow-none md:border-none'
//           } transition-all duration-300 ease-in-out md:flex md:items-center md:justify-end md:flex-1`}>
//             <a href="#home" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Home</a>
//             <a href="#about" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">About Us</a>
//             <a href="#coaching" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Coaching</a>
//             <a href="#programs" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Programs</a>
//             <a href="#contact" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Contact</a>
//           </nav>
          
//           <button 
//             className="md:hidden flex flex-col bg-transparent border-none cursor-pointer p-2 -mr-2 z-50 relative"
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//             aria-label="Toggle menu"
//           >
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-[6px]' : ''}`}></span>
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 my-1 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-[6px]' : ''}`}></span>
//           </button>
//         </div>
//       </div>
      
//       {/* Mobile menu overlay */}
//       {isMenuOpen && (
//         <div 
//           className="fixed inset-0 bg-black/20 z-40 md:hidden" 
//           onClick={() => setIsMenuOpen(false)}
//         />
//       )}
//     </header>
//   );
// };

// export default Header;
// import React, { useState } from 'react';
// import logo from '../assets/Logo 1.svg';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   return (
//     <header className="fixed top-0 left-0 right-0 bg-white z-[1000] py-3 sm:py-4 transition-all duration-300 border-b border-gray-200">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex items-center justify-between w-full">
//           <div className="flex items-center flex-shrink-0">
//             <img 
//               src={logo} 
//               alt="Tennis Community Logo" 
//               className="h-10 sm:h-12 w-auto object-contain" 
//               style={{ filter: 'none', backfaceVisibility: 'hidden', transform: 'translateZ(0)' }}
//             />
//           </div>
          
//           <nav className={`${
//             isMenuOpen 
//               ? 'flex' 
//               : 'hidden'
//           } md:flex fixed md:relative top-[64px] sm:top-[72px] md:top-auto left-0 md:left-auto right-0 md:right-auto bg-white md:bg-transparent flex-col md:flex-row py-6 md:py-0 px-4 md:px-0 shadow-xl md:shadow-none border-t md:border-t-0 border-gray-200 md:border-none z-[1001] md:z-auto md:items-center md:justify-end md:flex-1`}>
//             <a href="#home" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Home</a>
//             <a href="#about" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">About Us</a>
//             <a href="#coaching" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Coaching</a>
//             <a href="#programs" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Programs</a>
//             <a href="#contact" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Contact</a>
//           </nav>
          
//           <button 
//             className="md:hidden flex flex-col bg-transparent border-none cursor-pointer p-2 -mr-2 z-[1002] relative"
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//             aria-label="Toggle menu"
//           >
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-[6px]' : ''}`}></span>
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 my-1 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
//             <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-[6px]' : ''}`}></span>
//           </button>
//         </div>
//       </div>
      
//       {/* Mobile menu overlay */}
//       {isMenuOpen && (
//         <div 
//           className="fixed inset-0 bg-black/20 z-[1000] md:hidden" 
//           onClick={() => setIsMenuOpen(false)}
//         />
//       )}
//     </header>
//   );
// };

// export default Header;
import React, { useState } from 'react';
import logo from '../assets/Logo 1.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-[1000] py-3 sm:py-4 transition-all duration-300 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between w-full md:justify-start md:gap-8">
          <div className="flex items-center flex-shrink-0">
            <img
              src={logo}
              alt="Tennis Community Logo"
              className="h-10 sm:h-12 w-auto object-contain"
              style={{ filter: 'none', backfaceVisibility: 'hidden', transform: 'translateZ(0)' }}
            />
          </div>

          <nav className={`${isMenuOpen
              ? 'flex'
              : 'hidden'
            } md:flex fixed md:relative top-[64px] sm:top-[72px] md:top-auto left-0 md:left-auto right-0 md:right-auto bg-white md:bg-transparent flex-col md:flex-row py-6 md:py-0 px-4 md:px-0 shadow-xl md:shadow-none border-t md:border-t-0 border-gray-200 md:border-none z-[1001] md:z-auto md:items-center md:flex-1 md:justify-evenly`}>
            <a href="#home" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Home</a>
            <a href="#about" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">About Us</a>
            <a href="#coaching" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Coaching</a>
            <a href="#programs" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Programs</a>
            <a href="#contact" className="text-gray-900 font-medium text-base transition-colors duration-300 hover:text-primary-500 active:text-primary-600 py-4 px-4 w-full text-center border-b border-gray-200 last:border-b-0 md:py-0 md:px-3 lg:px-4 md:w-auto md:border-b-0 md:text-base">Contact</a>
          </nav>

          <button
            className="md:hidden flex flex-col bg-transparent border-none cursor-pointer p-2 -mr-2 z-[1002] relative"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-[6px]' : ''}`}></span>
            <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 my-1 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-5 h-[2px] bg-gray-900 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-[6px]' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* Mobile menu overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-[1000] md:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;